import classNames from "classnames/bind";
import styles from "./LiveVideo.module.css";
import Header from "./Header";
import StreamCamera from "./StreamCamera";
import React, { useContext, useEffect, useState } from "react";
import streamingClient from "../../../../services/streamingClient";
import { LisencePlateContext } from "../../../../contexts";
import { LoadComponent, Pagination } from "../../../../components";
import axiosClient from "../../../../services/axiosClient";

const cx = classNames.bind(styles);

const LiveVideo = () => {
  const { screen, cameraCode,showInfo,
    setShowInfo,
    info,
    setInfo } = useContext(LisencePlateContext);
  const [streaming, setStreaming] = useState([]);
  const [isLoadingCamera, setIsLoadingCamera] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  React.useEffect(() => {
    const getListPathStreaming = async () => {
      if (cameraCode && cameraCode.length > 0) {
        try {
          let listCameraCode = [];
          if (screen && screen.total === 1) {
            listCameraCode = [cameraCode[currentPage - 1]];
          } else {
            listCameraCode = cameraCode?.map((item) => {
              return { camera_code: item.camera_code };
            });
          }
          if (listCameraCode.length > 0) {
            const res = await streamingClient.post(
              "/streamManagement/post-list-path-streaming/",
              {
                list_camera: {
                  data: listCameraCode,
                },
              }
            );
            const listStream = res?.stream.map((item) => {
              if (item.code) {
                return {
                  url: `${process.env.REACT_APP_BASE_URL}livestream${
                    item.data.length > 1
                      ? item?.data[1].PATH
                      : item?.data[0].PATH
                  }`,
                  url2: `${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`,
                  isOption: false,
                  name: item?.name,
                  status:
                    item?.status_active === 3
                      ? "Off"
                      : (item?.status_active === 2) |
                        (item?.status_active === 1)
                      ? "Weak"
                      : "On",
                  code: item.code,
                };
              }
              return null;
            });
            setStreaming(listStream);
            setIsLoadingCamera(false);
          } else {
            setStreaming([]);
            setIsLoadingCamera(false);
          }
        } catch (error) {
          setIsLoadingCamera(false);
          setStreaming([]);
          // throw new Error("We can't get path streaming");
        }
      }
      else{
        setStreaming([])
      }
      setIsLoadingCamera(false);
    };
    const x = setInterval(() => {
      getListPathStreaming();
    }, 60000);
    getListPathStreaming();
    return () => {
      clearInterval(x);
    };
  }, [cameraCode, currentPage]);
  return (
    <div className={cx("container")}>
      {isLoadingCamera ? (
        <div>
          <LoadComponent />
        </div>
      ) : (
        <>
          <Header />
          {streaming?.map((item) => {
            return <StreamCamera data={item} />;
          })}
          {cameraCode.length > 1 && screen.total === 1 && (
            <div className={cx("pagination")}>
              <Pagination
                pages={cameraCode.length}
                currentPage={currentPage}
                onClick={(e) => {
                  setInfo({})
                  setShowInfo(false)
                  setCurrentPage(e);
                  
                }}
                onNext={() => {
                  setInfo({})
                  setShowInfo(false)
                  setCurrentPage(currentPage + 1);
                }}
                onPrevious={() => {
                  setInfo({})
                  setShowInfo(false)
                  setCurrentPage(currentPage - 1);
                }}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LiveVideo;
